export default __webpack_public_path__ + "5d680c6b80f7fbd914672d2eaa9b38d1.png";